/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import ModalDonateNonNftStyled from './styled'
import { notification } from 'antd'
import Button from 'shared/Button'
import { CLOSE_BTN, LINE_GUILD_GRADIENT, TWO_LINE } from 'assets/images'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import { NUMBER, STRING } from 'apps/constants'
import { handleAsyncRequest } from 'utils/helper'
import guildApi from 'apis/guildApi'
import { useAppDispatch, useAppSelector, useToggle, useUpdateEffect } from 'hooks'
import InProgressBalanceModal from 'features/Balance/components/InProgress'
import itemApi from 'apis/itemApi'
import { GetRaceListParams } from 'models'
import { RaceTable } from 'features/Race/components'
import { guildDonateNonNftColumns } from 'utils/columns'
import ReactPaginate from 'react-paginate'
import { getNonNftList } from 'apps/redux/userCreateRace/action'
import ModalConfirm from 'features/Guild/components/ModalConfirmEditGuild'

interface ModalProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  onConfirmDonate: () => void
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.FORTY,
  page: NUMBER.ONE
}

export default function DonateNonNft({ onCloseButtonClick, onConfirmDonate }: ModalProps) {
  const [api, contextHolder] = notification.useNotification()
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [openInProgressBalanceModal, toggleOpenInProgressBalanceModal] = useToggle(false)
  const [dataItems, setDataItems] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const [tokenIds, setTokenIds] = useState<number[]>([])
  const dispatch = useAppDispatch()
  const [isConfirm, setIsConfirm] = useState(false)
  const [isConfirmMulti, setIsConfirmMulti] = useState(false)

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      getListItems()
    }
  }, [params, profile.guild_id])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })
    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListItems = async () => {
    setLoading(true)
    const [error, result]: any = await handleAsyncRequest(itemApi.getAllNonNft(params))
    if (error) {
      openNotification(STRING.ERROR, error.message || error.errors[0]?.message)
    }
    if (result) {
      const formatData = result.data.records.map((record: any, index: number) => {
        return {
          ...record,
          noCustom: (params.page - 1) * params.limit + index + 1,
          raceName: record.boost?.name,
          avatar: record.boost?.img,
          boost_type: record.boost?.boost_type,
          inputAmount: '',
          isSelected: tokenIds.includes(record.boost?.id),
          maxValue: record.amount,
          quantity: record.amount
        }
      })
      setDataItems(formatData)
      setTotal(result.data?.total || NUMBER.ZERO)
    }

    setLoading(false)
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildDonateNonNftColumns
  }, [profile])

  const transactionSuccess = () => {
    toggleOpenInProgressBalanceModal(false)
    notification.success({
      message: 'SUCCESS',
      description: `Donate successfully!`,
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-success'
    })
    dispatch(getNonNftList({ guildId: profile.guild_id, params: defaultParams }))
  }

  const handleConfirmSubmit = async () => {
    const donate_booster = tokenIds.map(id => {
      const dataItem = dataItems.find((item: any) => item.boost?.id === id)
      return {
        amount: Number(dataItem.inputAmount),
        booster_id: dataItem.boost?.id
      }
    })
    setLoadingSubmit(true)
    const payload = {
      donate_booster,
      guild_id: Number(profile?.guild_id)
    }
    const [error, result]: any = await handleAsyncRequest(guildApi.postDonateNonNft(payload))
    if (error) {
      setLoadingSubmit(false)
      return
    }
    if (result) {
      transactionSuccess()
      onConfirmDonate()
    }
  }

  const handlePageClick = (event: any) => {
    setParams({ ...params, page: event.selected + 1 })
  }

  const handleSave = () => {
    if (tokenIds?.length === 1) {
      setIsConfirm(true)
    } else {
      setIsConfirmMulti(true)
    }
  }

  const disabledSave = useMemo(() => {
    if (!tokenIds.length) return true
    const itemSelected = dataItems.filter((it: any) => tokenIds.includes(it.boost?.id))
    const isFailed = itemSelected?.some((it: any) => !Number(it.inputAmount))
    return isFailed
  }, [dataItems, tokenIds])

  return (
    <Modal>
      <ModalDonateNonNftStyled>
        {contextHolder}
        <div className='donate-coin-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-modal'>
            <div className={`color-primary`}>{t(`${GUILD_MESSAGE}.donateToGuildVault`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='content-modal'>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <div className='container'>
              <div>
                <RaceTable
                  columns={memoizedResultListSelectionColumns}
                  data={dataItems}
                  isHasMore={false}
                  raisePage={setParams}
                  loader={!loading}
                  params={params}
                  checkLoadingPage={false}
                  totalRace={total}
                  currentUser={profile}
                  noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
                  isShowVipIcon={true}
                  onClickOneCell={id => {
                    setTokenIds(prev => {
                      if (prev.includes(id)) {
                        return prev.filter(item => item !== id)
                      }
                      return [...prev, id]
                    })
                    const newItems = dataItems.map((it: any) =>
                      it.boost?.id === id ? { ...it, isSelected: !it.isSelected } : it
                    )
                    setDataItems(newItems)
                  }}
                  onChangeOneCell={(rowId, value) => {
                    const result = dataItems.map((item: any) => {
                      if (item.boost.id === Number(rowId)) {
                        return {
                          ...item,
                          inputAmount: Number(value) > item.maxValue ? item.maxValue : value
                        }
                      }
                      return item
                    })
                    setDataItems(result)
                  }}
                />
              </div>
              <div className='pagination custom'>
                {dataItems.length > 0 && Number(total) > 10 && (
                  <div className='paginate'>
                    <ReactPaginate
                      nextLabel='>'
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={Math.ceil(Number(total) / params.limit)}
                      previousLabel='<'
                      pageClassName='page-item'
                      pageLinkClassName='page-link'
                      previousClassName='page-item'
                      previousLinkClassName='page-link'
                      nextClassName='page-item'
                      nextLinkClassName='page-link'
                      breakLabel='...'
                      breakClassName='page-item'
                      breakLinkClassName='page-link'
                      containerClassName='pagination'
                      activeClassName='active'
                      forcePage={params.page ? +params.page - 1 : 0}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className='actions-container'>
              <div className='balance-container'>
                <div className='donate'>
                  <div className='action'>
                    <Button
                      type='btnCancel'
                      buttonName={t(`${GUILD_MESSAGE}.cancel`)}
                      onClickButton={onCloseButtonClick}
                      width={147}
                    />
                    <Button
                      isLoading={loadingSubmit}
                      buttonName={t(`${GUILD_MESSAGE}.donate`)}
                      onClickButton={handleSave}
                      disabled={disabledSave}
                      width={147}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openInProgressBalanceModal && <InProgressBalanceModal title={'DONATE IN PROGRESS'} />}
        {isConfirm && (
          <ModalConfirm
            onClose={() => setIsConfirm(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re donating {dataItems.find((it: any) => it.boost?.id === tokenIds?.[0])?.inputAmount}</div>
                  <div>
                    <img
                      width='25px'
                      height='25px'
                      style={{ objectFit: 'contain' }}
                      className='mr-2'
                      alt='Merah'
                      src={dataItems.find((it: any) => it.boost?.id === tokenIds?.[0])?.boost?.img}
                    />
                  </div>
                  <div>{dataItems.find((it: any) => it.boost?.id === tokenIds?.[0])?.boost?.name}</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
        {isConfirmMulti && (
          <ModalConfirm
            onClose={() => setIsConfirmMulti(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re about to donate multiple items.</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
      </ModalDonateNonNftStyled>
    </Modal>
  )
}
